<template>
    <v-col class="box-diagnostico" cols="12" lg="12">
        <div class="box-ecg justify-start">
            <div class="ecg-line"></div>
            <label class="status-diagnostico">{{ equipamento.diagnostico }}</label>
        </div>
    </v-col>
    <v-col class="container-alarme" cols="12" lg="12">
        <div class="box-alarme">
            <v-row>
                <v-col cols="6" class="col-alerta">
                    <p class="titulo-alertas">Alertas: </p>
                </v-col>
                <v-col cols="6" class="col-alerta">
                    <div class="box-alerta">
                        <div class="alerta">
                            <v-badge class="badge-alarme" :content="equipamento.equipamento.qtdAlarme" offset-y="-10">
                                <font-awesome-icon class="icon-size" :icon="['fas', 'bell']" />
                            </v-badge>
                            <label class="fonte-reduzida">Alarme</label>
                        </div>
                        <div class="alerta">
                            <v-badge class="badge-trip" :content="equipamento.equipamento.qtdTrip" offset-y="-10">
                                <font-awesome-icon class="icon-size" :icon="['fas', 'bell']" />
                            </v-badge>
                            <label class="fonte-reduzida">Trip</label>
                        </div>
                    </div>
                </v-col>
                <div class="linha-alerta d-flex justify-center w-100">
                    <hr color="#393850" width="90%">
                </div>
                <v-col cols="12" class="box-mensagem-alerta">
                    <div>
                        <p class="alarme-ativo">{{ equipamento.alarmesAtivos[indiceAtual] }}</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-col>
</template>

<script>
    import { ref, onMounted, onUnmounted } from "vue";

    export default {
        props: {
            equipamento: Object
        },
        setup(props) {
            const indiceAtual = ref(0);

            const trocarAlarme = () => {
                if (props.equipamento?.alarmesAtivos?.length) {
                    indiceAtual.value = (indiceAtual.value + 1) % props.equipamento.alarmesAtivos.length;
                }
            };

            let intervaloAlarmes;

            onMounted(() => {
                intervaloAlarmes = setInterval(trocarAlarme, 10000);
            });

            onUnmounted(() => {
                clearInterval(intervaloAlarmes);
            });

            return {
                indiceAtual
            };
        }
    };
</script>

<style scoped>
.box-diagnostico {
    display: flex;
    flex-direction: column;

    .titulo-diagnostico {
        position: relative;
        right: 245px;
        font-weight: 500;
        font-style: italic;
        font-size: 16px;
        line-height: 18.75px;
        top: 12px;
    }
}

.box-ecg {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .status-diagnostico {
        font-weight: 700;
        font-size: 16px;
        line-height: 18.75px;
        text-align: center;
        color: var(--amarelo-alerta);
    }
}

.ecg-line {
    background: var(--ecg);
    width: 230px;
    height: 35px;
    background-repeat: no-repeat;
}

.container-alarme {
    display: flex;
}

.box-alarme {
    display: grid;
    width: 361px;
    height: 140px;
    border-radius: 5px;
    background: var(--linear-azul-diagnostico);
    padding: 10px;

    p {
        font-weight: 600;
        font-size: 16px;
        line-height: 18.75px;
        text-align: center;
        color: var(--amarelo-alerta);
    }
}

.col-alerta {
    display: flex;
    align-items: center;
    height: 70px;
    justify-content: center;
}

.box-alerta {
    width: 90%;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
}

.alerta {
    gap: 10px;
    display: flex;
    align-items: center;
}

.icon-size {
    font-size: 20px !important;
    color: black;
}

.badge-alarme ::v-deep(.v-badge__badge) {
    background: #8D750D !important;
}

.badge-trip ::v-deep(.v-badge__badge) {
    background-color: #A31010 !important;
}

.icon-size {
    font-size: 20px !important;
}

.alarme-ativo {
    color: var(--text-color) !important;
}

.linha-alerta {
    margin-top: -35px;
    height: 1px;
}

.box-mensagem-alerta {
    margin-top: -50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.titulo-alertas {
    color: #FFFFFF !important;
    ;
    font-weight: 600;
    font-size: 16px;
    line-height: 18.75px;
}

@media screen and (max-width: 960px) {
    .box-alarme {
        width: 100%;
    }
}
</style>